export default {
  namespaced: true,

  state: {
    techMessageHeight: 0,
    dataLoaded: false
  },

  getters: {
    techMessageHeight: state => state.techMessageHeight,
  },

  mutations: {
    setTechMessageHeight(state, payload) {
      state.techMessageHeight = payload
    },

    setDataLoaded(state, payload) {
      state.dataLoaded = payload
    }
  },

  actions: {
    setTechMessageHeight({ commit }, payload) {
      commit('setTechMessageHeight', payload)
    }
  }
}
